import { Component, OnInit, Pipe, PipeTransform, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { User } from './user';
import { UserService } from './user.service';
import { Overlay } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { DialogRef } from 'ngx-modialog';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';


@Component({
    selector: 'my-users',
    templateUrl: 'internaluser.component.html',
    providers: [Modal]

})
export class InternalUserComponent implements OnInit {
    users: User[];
    filteredUsers: User[];

    dialog: any;
    result: any;
    selectedUser: User;
    addingUser = false;
    errorResponse: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    deleting = false;
    userViewType = 'View All';
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    constructor(
        private toasterService: ToasterService,
        private _service: NotificationsService,
        private router: Router,
        private userService: UserService,
        public modal: Modal
    ) { }

    createNotification() {
        this.toasterService.pop(this.notificationType, this.notificationTitle, this.notificationContent);
    }

    errorHandler(error: any) {
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
        this.deleting = false;
    }


    getUsers() {
        return this.userService
            .getUsers()
            .then(res => {
                this.users = res.user;
                this.clickViewType('View All');
            })
            .catch(error => this.errorHandler(error));
    }

    addUser() {
        this.addingUser = true;
        this.selectedUser = null;
    }

    close(savedUser: User) {
        this.addingUser = false;
        if (savedUser) { this.getUsers(); }
    }




    deleteUser(user: User, event: any) {
        event.stopPropagation();
        this.userService
            .delete(user)
            .then(res => {
                this.users = this.users.filter(u => u !== user);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'User : ' + user.user_email + ' is deleted';
                this.createNotification();
                this.deleting = false;

                if (this.selectedUser === user) { this.selectedUser = null; }
            })
            .catch(error => this.errorHandler(error));
    }

    ngOnInit() {
        this.getUsers();
    }

    onSelect(user: User) {
        this.selectedUser = user;
        this.addingUser = false;
    }

    gotoDetail(user: User) {
        this.router.navigate(['/parrot', user.user_id]);
    }

    selectCreateUser() {
        this.router.navigate(['/parrot/create']);
    }

    onClickActivationUser(user: User, event: any) {
        event.stopPropagation();
        const dialogMessage = user.status === 1 ? 'You really want to deactivate this customer?' : 'You really want to activate this customer?';
        this.deleting = true;
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        this.processDialogActivation(user, event, this.dialog);
    }

    private processDialogActivation(user: User, event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                if (user.status === 1) {
                    user.status = 0;
                } else {
                    user.status = 1;
                }
                this.save(user);
            }, () => {
                this.deleting = false;
                this.result = 'Rejected!';
            });
        });
    }

    save(user: User) {
        this.userService
            .updateUser(user)
            .then(res => {
                this.deleting = false;
                this.getUsers();
            })
            .catch(error => {
                if (user.status === 1) {
                    user.status = 0;
                }
                else {
                    user.status = 1;
                }
                this.deleting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                const jsonErrorBody = JSON.parse(error._body);
                this.notificationContent = jsonErrorBody.error.message;
                this.createNotification();
            });
    }
    clickViewType(event: any) {
        if (this.userViewType === 'View All') {
            this.filteredUsers = this.users;
            this.filteredUsers.sort((leftSide, rightSide): number => {
                if (leftSide.status < rightSide.status) {
                    return 1;
                } else if (leftSide.status > rightSide.status) {
                    return -1;
                } else if (leftSide.status === rightSide.status && leftSide.user_id > rightSide.user_id) {
                    return -1;
                } else if (leftSide.status === rightSide.status && leftSide.user_id < rightSide.user_id) {
                    return 1;
                }
                return 0;
            });
        } else if (this.userViewType === 'View Active') {
            this.filteredUsers = this.users.filter(c => c.status === 1);
        } else {
            this.filteredUsers = this.users.filter(c => c.status === 0);
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/user/internaluser.component.ts